import React, { useState, useEffect, useRef } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminInverter(props) {
    const forminvRef = useRef(null)

    const [inv_model, setINV_Model] = useState('');
    const [inverterlist, setInverterlist] = useState([]);
    const [inverteritem, setInverteritem] = useState({
        id: 0,
        model_no: '',
        meter_id: 0,
        ipaddress: '',
        modbus_id: 0,
        string_capacity: 0,
        serial_no: ''
    });

    const [mode, setMode] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_inverter, setModal_inverter] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
        api_delete_data()
    }

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            setINV_Model(props.data_uioption.inv_model)
        }
    }, [props.data_uioption]);

    useEffect(() => {
        api_get_list()
        return () => {
            setInverterlist([]);
        }
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading inverter list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/inverter/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setInverterlist(response.data.inverter)
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function manageInverter(mode, selectdata) {
        if (mode === 'add') {
            setMode('add')
            setInverteritem({
                id: 0,
                model_no: inv_model,
                meter_id: 0,
                ipaddress: '',
                modbus_id: 0,
                string_capacity: 0,
                serial_no: ''
            })
            setModal_inverter(true)
        }
        else if (mode === 'edit') {
            setMode('edit')
            setInverteritem(selectdata)
            setModal_inverter(true)
        }
        else if (mode === 'delete') {
            setInverteritem(selectdata)
            setModal_popup({
                modaltype: 'modal-confirm',
                headers: 'Confirmation',
                message: "Please click on confirm button to continue this operation.",
                enable: true
            });
        }
    }

    async function api_save_data() {
        var formelement = forminvRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('id', inverteritem.id)
            formData.append('meter_id', inverteritem.meter_id)
            formData.append('ipaddress', inverteritem.ipaddress)
            formData.append('modbus_id', inverteritem.modbus_id)
            formData.append('model_no', inverteritem.model_no)
            formData.append('string_capacity', inverteritem.string_capacity)
            formData.append('serial_no', inverteritem.serial_no)

            setmodal_load({ enable: true, message: "Saving inverter." })
            await sleep(500)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/inverter/" + mode, formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_inverter(false)
                    setInverteritem({
                        id: 0,
                        model_no: '',
                        meter_id: 0,
                        ipaddress: '',
                        modbus_id: 0,
                        string_capacity: 0,
                        serial_no: ''
                    })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your inverter has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.inverter !== undefined) {
                        setInverterlist(response.data.inverter)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_inverter(false)
                    setInverteritem({
                        id: 0,
                        model_no: '',
                        meter_id: 0,
                        ipaddress: '',
                        modbus_id: 0,
                        string_capacity: 0,
                        serial_no: ''
                    })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_delete_data() {
        setmodal_load({ enable: true, message: "Deleting inverter." })
        await sleep(500)

        const formData = new FormData();
        formData.append('id', inverteritem.id)
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/inverter/delete", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                setInverteritem({
                    id: 0,
                    model_no: '',
                    meter_id: 0,
                    ipaddress: '',
                    modbus_id: 0,
                    string_capacity: 0,
                    serial_no: ''
                })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your inverter has been deleted fron database.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.inverter !== undefined) {
                    setInverterlist(response.data.inverter)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setInverteritem({
                    id: 0,
                    model_no: '',
                    meter_id: 0,
                    ipaddress: '',
                    modbus_id: 0,
                    string_capacity: 0,
                    serial_no: ''
                })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-bolt"></i> Inverter</h4>
                                    <p className="mb-3">Manage all inverters</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-info btn-sm" onClick={() => { manageInverter("add") }}><i className="fas fa-plus"></i> Add Inverter</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Inverter Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>No.</th>
                                        <th>Inverter ID.</th>
                                        <th>Meter ID.</th>
                                        <th>Model No.</th>
                                        <th>Serial No</th>
                                        <th>IP Address</th>
                                        <th>Modbus ID</th>
                                        <th>String Capacity (kWp)</th>
                                        <th>Edit Time</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        inverterlist.map((inverter, index) => (
                                            <tr key={inverter.id}>
                                                <td><i className="fas fa-bolt rows-icon"></i> {index + 1}</td>
                                                <td>{inverter.id}</td>
                                                <td>{inverter.meter_id}</td>
                                                <td>{inverter.model_no}</td>
                                                <td>{inverter.serial_no}</td>
                                                <td>{inverter.ipaddress}</td>
                                                <td>{inverter.modbus_id}</td>
                                                <td>{inverter.string_capacity}</td>
                                                <td>{moment(new Date(inverter.edittime)).format('YYYY-MMM-DD HH:mm:ss')}</td>
                                                <td>
                                                    <Link className="btn btn-icon btn-sm btn-success btn-hover btn-bordered" title="Edit" onClick={() => { manageInverter('edit', inverter) }}><i className="fas fa-pen"></i></Link>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                    {
                        modal_inverter ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fas fa-bolt"></i> {mode === "add" ? "Add" : "Edit"} Inverter</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_inverter(false) }}></i>
                                            </div>
                                            <div className="modal-body" style={{ minHeight: "320px" }}>
                                                <div className='row'>
                                                    <div className="col-12">
                                                        <form ref={forminvRef} action="" method="POST" encType="multipart/form-data" >
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="inverter_id">Inverter ID</label>
                                                                        <input type="number" className="form-control" name="inverter_id" min={1} max={256} value={inverteritem.id} onChange={(e) => {
                                                                            setInverteritem({
                                                                                ...inverteritem,
                                                                                id: e.target.value
                                                                            })
                                                                        }} required disabled={mode === "edit"} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="meter_id">Meter ID</label>
                                                                        <input type="number" className="form-control" name="meter_id" min={1} max={3} value={inverteritem.meter_id} onChange={(e) => {
                                                                            setInverteritem({
                                                                                ...inverteritem,
                                                                                meter_id: e.target.value
                                                                            })
                                                                        }} required />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="ipaddress">IP Address (IPV4)</label>
                                                                        <input type="text" className="form-control" name="ipaddress" pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" value={inverteritem.ipaddress} onChange={(e) => {
                                                                            setInverteritem({
                                                                                ...inverteritem,
                                                                                ipaddress: e.target.value
                                                                            })
                                                                        }} required />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="modbus_id">Modbus ID</label>
                                                                        <input type="number" className="form-control" name="modbus_id" min={1} max={256} value={inverteritem.modbus_id} onChange={(e) => {
                                                                            setInverteritem({
                                                                                ...inverteritem,
                                                                                modbus_id: e.target.value
                                                                            })
                                                                        }} required />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="model_no">Model No.</label>
                                                                        <input type="text" className="form-control" name="model_no" value={inverteritem.model_no} required readOnly />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="string_capacity">String Capacity (kWp)</label>
                                                                        <input type="number" className="form-control" name="string_capacity" min={1} value={inverteritem.string_capacity} onChange={(e) => {
                                                                            setInverteritem({
                                                                                ...inverteritem,
                                                                                string_capacity: e.target.value
                                                                            })
                                                                        }} required />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className="col-md-6">
                                                                    <div className="form-group mb-3">
                                                                        <label htmlFor="serial_no">Serial No.</label>
                                                                        <input type="text" className="form-control" name="serial_no" value={inverteritem.serial_no} onChange={(e) => {
                                                                            setInverteritem({
                                                                                ...inverteritem,
                                                                                serial_no: e.target.value
                                                                            })
                                                                        }} required />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_inverter(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_save_data() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminInverter